import client from '../httpClient';

const getSmsTalkApi = (smsCustomerTelId) => {
  return client.get(`/sms/${smsCustomerTelId}`);
};

export default getSmsTalkApi;
